<template>
  <el-dialog
    width="40%"
    class="dialog"
    :title="type == 'add' ? '提交回收申请' : '预约派车'"
    :visible.sync="dialogFormVisible"
  >
    <div class="tips">
      提示：请和网点确认回收信息，如果回收地址为空需要让网点前往网点档案中补充
    </div>
    <el-form
      ref="ruleForm"
      label-position="right"
      :rules="rules"
      :model="formData"
      label-width="120px"
    >
      <el-form-item
        label="预约回收日期"
        prop="appointDate"
        v-show="type == 'add'"
      >
        <el-row justify="space-between">
          <el-col :span="12">
            <el-date-picker
              v-model="formData.appointDate"
              type="date"
              placeholder="选择日期"
              style="width: 100%"
              value-format="yyyy-MM-dd"
              @change="changeDate"
              :picker-options="{
                disabledDate: time => $day(time).isBefore($day(), 'day')
              }"
            >
            </el-date-picker>
          </el-col>
          <el-col :span="12">
            <el-select
              :disabled="!formData.appointDate"
              v-model="pickerData"
              placeholder="请选择时间段"
              @change="openChange()"
            >
              <el-option
                :value="item.value"
                v-for="item in pickerList"
                :key="item.value"
                >{{ item.label }}</el-option
              >
            </el-select>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="承运商" prop="carrierNo">
        <el-select
          v-model="formData.carrierNo"
          placeholder="请选择"
          clearable
          style="width: 100%"
          @change="changeCarrier"
          :disabled="type == 'edit' && partnershipType !== 3"
          filterable
        >
          <el-option
            v-for="item in carrierOption"
            :key="item.carrierNo"
            :label="item.carrierName"
            :value="item.carrierNo"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <template v-if="formData.carrierNo !== '4'">
        <el-form-item label="回收人员" prop="recoveryWorker">
          <el-select
            @change="changeWorker"
            v-model="formData.recoveryWorker"
            placeholder="请选择"
            clearable
            style="width: 100%"
            filterable
          >
            <el-option
              v-for="item in engineerList"
              :key="item.id"
              :label="item.name"
              :value="item.id"

            >
            </el-option>
          </el-select>
        </el-form-item>
      </template>
      <el-form-item label="网点" class="read-only"
        >{{ formData.networkNo }}{{ formData.networkName }}</el-form-item
      >
      <el-form-item label="回收地址" class="read-only" prop="address">{{
        (formData.province || "") +
          (formData.city || "") +
          (formData.county || "") +
          (formData.address || "")
      }}
        <span v-if="formData.address">
            <img v-if="!dataVisible.address" src="@/assets/eye-close.png" @click="toggleVisibility('address')" />
            <img v-else src="@/assets/eye-open.png" @click="toggleVisibility('address')" />
          </span>
      </el-form-item>
      <el-form-item label="回收数量" class="read-only" prop="recoveryNum">{{
        formData.recoveryNum
      }}</el-form-item>
      <el-form-item label="预估方数" class="read-only" prop="estimateVolume">{{
        formData.estimateVolume
      }}</el-form-item>
      <el-form-item label="预估重量" class="read-only" prop="estimateWeight">{{
        formData.estimateWeight
      }}</el-form-item>
      <el-form-item label="归集仓库" class="read-only"
        >{{ formData.warehouseNo }}{{ formData.warehouseName }}</el-form-item
      >
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" :disabled="btnLoading" @click="submitBtnFun"
        >提交</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import {
  getOldMachineRepertoryDetail,
  saveRecoveryApply,
  getEngineerList,
  getPartner,
  changeOrder
} from "@/api/oldForNew";
import { get } from "echarts/lib/CoordinateSystem";

export default {
  components: {
    getOldMachineRepertoryDetail
  },
  data() {
    return {
      partnershipType: null, //当前用户所属组织 1 子公司 2 第三方 3 总公司

      dialogFormVisible: false,
      type: "add", //add 创建回收单模式 edit改派模式
      orderNo: "", //订单 id 改派的时候需要
      engineerList: [], //回收师傅待选列表
      params: {
        outletsNo: "",
        provinceCode: "",
        cityCode: ""
      },
      formData: {
        appointDate: this.type == "edit" ? "test" : "", //仅用于页面提交资格校验 不用于提交
        appointStartDate: "", //预约开始时间
        appointEndDate: "", //预约结束时间
        carrierNo: "",
        carrierName: ""
      },
      pickerData: undefined, //对应日期的时间段
      carrierOption: [], //承运商待选列表
      rules: {
        appointDate: [
          {
            required: true,
            message: "请选择预约时间段",
            trigger: "blur"
          }
        ],
        carrierNo: [
          {
            required: true,
            message: "请选择承运商",
            trigger: "blur"
          }
        ],
        recoveryWorker: [
          {
            required: true,
            message: "请选择回收师傅",
            trigger: "blur"
          }
        ]
      },
      btnLoading: false,
      originData: {},
      dataVisible: {
				address: false,
			},
      address:''
    };
  },
  watch: {
    "formData.carrierNo": function(val) {
      if (val == "4") {
        this.rules.recoveryWorker[0].required = false;
      } else {
        this.rules.recoveryWorker[0].required = true;
      }
    }
  },
  computed: {
    pickerList() {
      let arr = [];
      let startTime = 8;
      let endTime = 22;

      for (let i = startTime; i < endTime; i++) {
        for (let j = 0; j < 60; j += 15) {
          let startHour = i < 10 ? "0" + i : i;
          let startMin = j === 0 ? "00" : j;
          let endHour = i < 10 ? "0" + i : i;
          let endMin = j + 15 === 60 ? "00" : j + 15;

          let value = `${startHour}:${startMin}-${endHour}:${endMin}`;
          let label = `${startHour}:${startMin}-${endHour}:${endMin}`;

          if (endMin === "00") {
            endHour = i + 1 < 10 ? "0" + (i + 1) : i + 1;
            arr.push({
              value: `${startHour}:${startMin}-${endHour}:00`,
              label: `${startHour}:${startMin}-${endHour}:00`
            });
          } else {
            arr.push({ value, label });
          }
        }
      }

      let currentHour = parseInt(this.$day(new Date()).format("HH"), 10);
      if (
        this.formData.appointDate === this.$day(new Date()).format("YYYY-MM-DD")
      ) {
        arr = arr.filter(item => {
          let endTime = parseInt(item.value.split("-")[1].split(":")[0], 10);
          let endMin = parseInt(item.value.split("-")[1].split(":")[1], 10);
          let currentMin = parseInt(this.$day(new Date()).format("mm"), 10);
          return (
            endTime > currentHour ||
            (endTime == currentHour && endMin > currentMin)
          );
        });
      }

      return arr;
    }
  },
  watch: {
    dialogFormVisible: function(val, oldVal) {
      if (!val) {
        this.$refs.ruleForm.resetFields();
      }
    }
  },
  methods: {
    // 关闭弹框
    closeDialog() {
      this.dialogFormVisible = false;
    },

    // 打开弹框
    async openDialog(rowData, flag) {
      this.type = flag;
      this.partnershipType = JSON.parse(
        localStorage.getItem("partnershipType")
      );
      this.pickerData = "";
      this.btnLoading = false;
      if (flag == "edit") {
        //改派（回收订单列表发起）

        this.params.outletsNo = rowData.networkNo;
        this.params.provinceCode = rowData.provinceCode;
        this.params.cityCode = rowData.cityCode;
        this.params.orderNo = rowData.orderNo;
        console.log("查询详情");
      } else {
        //创建回收单（旧机库存列表发起）
        this.params.outletsNo = rowData.outletsNo;
        this.params.provinceCode = rowData.provinceId;
        this.params.cityCode = rowData.cityId;
      }

      await this.getDetail();
      await this.getPartnerList();
      await this.getEngineerList();

      this.dialogFormVisible = true;
    },
    //获取回收师傅列表（基于承运商id）
    async getEngineerList() {
      if (!this.formData.carrierNo) {
        // this.$message.warning("请先选择承运商");
        return;
      }

      let { statusCode, data } = await getEngineerList(this.formData.carrierNo);
      if (statusCode == 200) {
        this.engineerList = data || [];
      }
      console.log("获取回收师傅", data);
    },
    //根据列表的网点编号 省市 id 获取回收详情 用于改派或者提交回收单
    async getDetail() {
      let { statusCode, data } = await getOldMachineRepertoryDetail(
        this.params
      );
      console.log("获取回收详情", data);

      if (statusCode == 200) {
        this.formData = data;
        this.originData = {...data};
        if (data.desensitizationDtoList && Array.isArray(data.desensitizationDtoList)) {
          const phoneMappings = {
            address_address: 'address',
          }

          data.desensitizationDtoList.forEach(item => {
            const targetProperty = phoneMappings[item.sensitizationCode]
            if (targetProperty) {
              this[targetProperty] = {
                sensitizationCode: item.sensitizationCode,
                message: item.message
              }
            }
          })
        }

        if (this.params.orderNo) {
          this.formData.orderNo = this.params.orderNo;
        }
      }
      this.btnLoading = false;
    },
    // 确认提交
    submitBtnFun() {
      if (!this.pickerData && this.type == "add") {
        this.$message.warning("请选择预约时间段");
        return;
      }
      if (this.type == "edit") {
        this.rules.appointDate[0].required = false;
      }

      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          delete this.formData.appointDate;

          this.btnLoading = true;
          if (this.type == "edit") {
            this.formData.orderNo = this.params.orderNo;

            //预约改派
            this.editFormDataReq();
          } else {
            //创建回收单
            this.saveFormDataReq();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    //新增回收单接口
    async saveFormDataReq() {
      let { statusCode, message } = await saveRecoveryApply(this.formData);
      if (statusCode == 200) {
        this.btnLoading = false;
        this.$message.success(this.type == "edit" ? "改派成功" : "新增成功");
        this.$emit("opera-success");
        this.dialogFormVisible = false;
      } else {
        this.$message.error(message);
      }
      this.btnLoading = false;
    },

    //改派接口
    async editFormDataReq() {
      this.formData.operateType = 1;
      this.changeCarrier();
      let { statusCode, message } = await changeOrder(this.formData);
      if (statusCode == 200) {
        this.$message.success("改派成功");
        this.$emit("opera-success");
        this.dialogFormVisible = false;
      } else {
        this.$message.error(message);
      }
      this.btnLoading = false;
    },

    // 表单重置
    resetFormStatus() {
      this.$refs.ruleForm.resetFields();
    },
    //更换承运商需要重新请求师傅列表
    async changeCarrier() {
      if (this.carrierOption.length && this.formData.carrierNo) {
        const selectedCarrier = this.carrierOption.find(
          item => item.carrierNo == this.formData.carrierNo
        );
        this.formData.carrierName = selectedCarrier
          ? selectedCarrier.carrierName
          : "";
      }
      this.engineerList = []; //清空旧工程师列表
      this.getEngineerList();
    },
    //获取承运商
    async getPartnerList() {
      let { statusCode, data } = await getPartner();
      if (statusCode == 200) {
        this.carrierOption = data;
      } else {
        this.carrierOption = [];
      }
    },
    //更改了日期
    changeDate() {
      this.pickerData = "";
    },
    //选择了某个时间段
    openChange() {
      if (this.formData.appointDate && this.pickerData) {
        this.formData.appointStartDate =
          this.formData.appointDate + " " + this.pickerData.split("-")[0];
        this.formData.appointEndDate =
          this.formData.appointDate + " " + this.pickerData.split("-")[1];
      } else {
        this.formData.appointStartDate = this.formData.appointStartDate = "";
      }
    },
    //选择师傅
    changeWorker(val) {
      const selectedEngineer = this.engineerList.find(item => item.id === val);
      this.formData.workerTel = selectedEngineer ? selectedEngineer.phone : "";
      this.formData.recoveryWorkerName = selectedEngineer
        ? selectedEngineer.name
        : "";
    },

    getSourceOrigin(data) {
      return this.HttpService.post(`/autoapp-default-server-recovery/api/deSensitization/getSource`, data).then(res => {
        if (res.statusCode === 200) {
          return res.data
        }
      })
    },
    toggleVisibility(dataType) {
      // 切换显示状态
      this.dataVisible[dataType] = !this.dataVisible[dataType]

      // 根据不同类型处理显示逻辑
      switch (dataType) {
        case 'address':
          if (this.dataVisible.address && this.address.message) {
            this.getSourceOrigin(this.address).then(res => {
              this.$set(this.formData, 'address', res)
            })
          } else if (!this.dataVisible.address) {
            // 还原为原始脱敏数据
            this.$set(this.formData, 'address', this.originData.address)
          }
          break
      }
    }
  }
};
</script>
<style scoped lang="scss">
.dialog {
  padding: 0 20px;
  .tips {
    margin-bottom: 10px;
  }
  .el-dialog__body {
    padding-top: 10px;
  }
  .dialog-footer {
    padding: 20px;
    padding-top: 0;
  }
  .el-form-item--small.el-form-item {
    &.read-only {
      margin-bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/oldForNewService/components/appointmentDialog.vue